import {Personnel} from "./personnel";
import {BaseModel} from "./base-model";
import {PhysicalAsset} from "./physical-asset";
import {CalendarEvent} from "./calendar-event";
import {Procedure} from "./procedure";
import {Task} from "./task";

export enum MaintenanceStatus {
  UNKNOWN = -1,
  OPEN,
  QUEUE,
  TAKEN,
  CLOSED,
  SUSPENDED,
  PLANNED,
}

export class MaintenanceStatusUtils {

  public static toString(status: MaintenanceStatus) {
    switch (status) {
      case MaintenanceStatus.OPEN:
        return 'Open';
      case MaintenanceStatus.QUEUE:
        return 'Queue';
      case MaintenanceStatus.TAKEN:
        return 'Taken';
      case MaintenanceStatus.CLOSED:
        return 'Closed';
      case MaintenanceStatus.SUSPENDED:
        return 'Suspended';
      case MaintenanceStatus.PLANNED:
        return 'Planned';
      default:
        return 'Unknown';
    }
  }

}

export class Maintenance extends BaseModel {

  protected static self = Maintenance;

  id: string;
  botDisconnectedAt: number;
  closedAt: number;
  closedBy: Personnel;
  createdAt: number;
  equipment: PhysicalAsset;
  equipmentId: string;
  event: CalendarEvent;
  eventId: string;
  fieldWorker: Personnel;
  isBotEnabled: boolean;
  isExtraordinary: boolean;
  isSupportRequired: boolean;
  isExternal: boolean;
  reason: string;
  recordingUrl: string;
  remoteExpert: Personnel;
  scheduledAt: number;
  status: MaintenanceStatus;
  takenInChargeAt: number;
  workInstructionId: string;
  workInstruction: Procedure;
  task: Task;
  assignedBy: Personnel;
  assignedAt: number;

  // Remap procedure to workInstruction for REST API
  get procedure() { return this.workInstruction; }
  set procedure(procedure) { this.workInstruction = procedure; }
  get procedureId() { return this.workInstructionId; }
  set procedureId(procedureId) { this.workInstructionId = procedureId; }

  constructor() {
    super();
    this.closedBy = new Personnel();
    this.equipment = new PhysicalAsset();
    this.event = new CalendarEvent();
    this.fieldWorker = new Personnel();
    this.remoteExpert = new Personnel();
    this.procedure = new Procedure();
  }

  public validate(): boolean {
    return true;
  }

}


export class MaintenanceProgress extends BaseModel {

  protected static self = MaintenanceProgress;

  maintenanceId: string;
  workInstructionId: string;
  taskId: string;
  stepId: string;
  isExecuted: boolean;
  executedAt: number;

  // Remap procedure to workInstruction for REST API
  get procedureId() { return this.workInstructionId; }
  set procedureId(procedureId) { this.workInstructionId = procedureId; }

  public validate(): boolean {
    return true;
  }

}
